import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

// Per-entity update form metadata: the CONTACT_PERSON_UPDATE attributes arrive
// prefilled with the person's current values (roleIds included).
export const ContactPersonUpdateTdas = gql`
    query ContactPersonUpdateTdas($contactPersonId: ID!) {
        contactPerson(id: $contactPersonId) {
            id
            typeDefinitionAttributeList {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
